import { handle } from "redux-pack";

function getLastUpdated(prevUpdated, payload) {
  if (payload) {
    return Date.now();
  } else {
    return prevUpdated;
  }
}

const initialDataStatus = {
  didInvalidate: false,
  error: null,
  isFetching: false,
  lastUpdated: 0,
  startFetching: 0
};

const handleDataStatus = (state, action) => {
  return handle(state, action, {
    start: prevState => ({
      ...prevState,
      error: null,
      isFetching: true,
      startFetching: Date.now()
    }),
    finish: prevState => ({
      ...prevState,
      isFetching: false
    }),
    failure: prevState => ({
      ...prevState,
      error: action.payload
    }),
    success: prevState => ({
      ...prevState,
      didInvalidate: false,
      lastUpdated: getLastUpdated(prevState.lastUpdated, action.payload)
    })
  });
};

export { handleDataStatus, initialDataStatus };
